import React, { useRef, useState } from "react";
import { StandaloneSearchBox } from "@react-google-maps/api";

function AutoAddressComponent({ isLoaded, onPlaceSelected, zip = "" }) {
  const [inputValue, setInputValue] = useState(zip || "");
  const inputRef = useRef(null);

  const handlePlacesChanged = () => {
    const places = inputRef.current.getPlaces();
    if (places && places.length > 0) {
      const selectedPlace = places[0];
      setInputValue(selectedPlace.formatted_address);
      onPlaceSelected(selectedPlace.formatted_address);
    }
  };


  return isLoaded ? (
    <StandaloneSearchBox
      onLoad={(ref) => (inputRef.current = ref)}
      onPlacesChanged={handlePlacesChanged}
    >
      <div className="flex items-center bg-white rounded-[34px] px-4 py-2">
        <input
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
          type="text"
          placeholder="Enter location"
          className="border-none outline-none bg-transparent text-sm md:text-base font-medium text-neutral80 placeholder:text-neutral30 w-full"
        />
      </div>
    </StandaloneSearchBox>
  ) : (
    <></>
  );
}

export default AutoAddressComponent;
